// extracted by mini-css-extract-plugin
module.exports = {"button":"CaptchaButton_button_2YT5k"};